import { FC, useEffect, useState } from "react";
import {
    Col,
    Container,
    FormLabel,
    Image,
    InputGroup,
    OverlayTrigger,
    Row,
    Stack,
    Table,
    Tooltip,
} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { activeIcon, backIcon, checkIcon, editIcon, eyeOff, eyeOn, trashIcon, userIcon } from "../../utils/Icons";
import CustomError from "../../utils/CustomError";
import {
    adminVerify,
    createSessionPersonas,
    getPersonas,
    sessionList,
    sessionsActivePersona,
    sessionsDeletePersona,
    updateSessionPersonas,
} from "../../api/request";
import Select from "react-select";
import { envUrls } from "../../api/baseUrl";
import { downloadSession } from "../../api/endPoints";

interface adminModal {
    show: boolean;
    onClose: () => void;
}

const AdminModal: FC<adminModal> = (props) => {


    const [showPassword, setShowPassword] = useState(false);

    const [login, setLogin] = useState<any>(false);
    const [errorAdmin, setErrorAdmin] = useState(false);
    const [useremail, setEmail] = useState<string>();
    const [password, setPassword] = useState<string>();
    const [personaList, setPersonaList] = useState<any>([]);
    const [sessionsList, setSessionList] = useState<any>([]);
    const [AdminId, setAdminId] = useState<string | null>();
    const [editSession, setEditSession] = useState(false);
    const [editSessionID, setEditSessionID] = useState("");


    const [error, setError] = useState({
        show: false,
        class: "",
        message: "",
    });
    const [sessionCreate, setCreateSession] = useState({
        table: true,
        form: false,
    });


    const [sessionDetails, setSessionDetails] = useState({
        session_id: "",
        session_name: "",
        password: "",
        admin_id: "",
    })

    const [listKey, setListKey] = useState<{ [key: string]: { provide: string; follow: string } }>({});

    const [traits, setTraits] = useState<string[]>([]);
    const [traitsDetails, setTraitsDetails] = useState<any>();

    const [validationErrors, setValidationErrors] = useState({
        session_id: '',
        session_name: '',
        password: '',
        traits: '',
    });

    useEffect(() => {
        if (traits.length > 0) {
            const newListKey: { [key: string]: { provide: string; follow: string } } = { ...listKey };
            traits.forEach((id: string) => {
                if (!newListKey[id]) {
                    newListKey[id] = {
                        provide: "Open",
                        follow: "Receptive",
                    };
                }
            });
            setListKey(newListKey);
        }
    }, [traits, sessionCreate?.table, sessionCreate?.form]);


    const handleSubmit = async () => {
        let errors = { session_id: '', session_name: '', password: '', traits: '' };
        if (/\s/.test(sessionDetails.session_id)) {
            errors.session_id = 'Spaces are not allowed in Session ID';
        }
        if (!sessionDetails.session_id.trim()) {
            errors.session_id = 'Session ID is required';
        }
        if (!sessionDetails.session_name.trim()) {
            errors.session_name = 'Session Name is required';
        }
        if (!sessionDetails.password.trim()) {
            errors.password = 'Session Password is required';
        }
        if (/\s/.test(sessionDetails.password)) {
            errors.password = 'Spaces are not allowed in Password';
        }
        if (traits.length === 0) {
            errors.traits = 'Please Select at least One Persona';
        }

        if (Object.values(errors).some((error) => error)) {
            setValidationErrors(errors);
            return;
        }

        const personas = traits.map((id: any) => {
            const persona = personaList.find((p: any) => p._id === id);
            return {
                name: persona?.name || "",
                persona_id: id,
                active: true,
                properties: {
                    open: listKey[id]?.provide === "Open",
                    Reserved: listKey[id]?.provide === "Reserved",
                    Receptive: listKey[id]?.follow === "Receptive",
                    Needs_Persuasion: listKey[id]?.follow === "Needs_Persuasion",
                }
            };
        });

        const payload = {
            ...sessionDetails,
            admin_id: AdminId,
            personas
        };
        if (!editSession) {
            const response = await createSessionPersonas(payload);
            if (response.flag) {
                setError({
                    show: true,
                    class: "show-error",
                    message: response?.message,
                });
                setCreateSession({
                    table: true,
                    form: false,
                });
                fetchSession();
                setTraits([]);
                setListKey({});
                setSessionDetails({
                    session_id: "",
                    session_name: "",
                    password: "",
                    admin_id: ""
                });
                setValidationErrors({
                    session_id: '',
                    session_name: '',
                    password: '',
                    traits: '',
                });
            } else {
                setError({
                    show: true,
                    class: "show-error",
                    message: response?.response?.data?.message,
                });
            }
        }
        else {
            const response = await updateSessionPersonas(editSessionID, payload);
            if (response.flag) {
                setError({
                    show: true,
                    class: "show-error",
                    message: response?.message,
                });
                setCreateSession({
                    table: true,
                    form: false,
                });
                setTraits([]);
                setListKey({});
                setSessionDetails({
                    session_id: "",
                    session_name: "",
                    password: "",
                    admin_id: ""
                });
                setValidationErrors({
                    session_id: '',
                    session_name: '',
                    password: '',
                    traits: '',
                });
                fetchSession();
                setEditSession(false);
            } else {
                setError({
                    show: true,
                    class: "show-error",
                    message: response?.response?.data?.message,
                });

            }
        }
    };

    const handleEdit = async (session: any) => {
        setCreateSession({
            table: false,
            form: true,
        });
        setEditSession(true);
        setEditSessionID(session?._id);
        setSessionDetails({
            session_id: session.session_id,
            session_name: session.session_name,
            password: session.password,
            admin_id: session?.admin_id
        });
        const selectedPersonaIds = session.personas?.map((persona: any) => persona.persona_id) || [];
        setTraits(selectedPersonaIds);
        setTraitsDetails(selectedPersonaIds[0] || "");
        const updatedListKey: any = {};

        session.personas.forEach((persona: any) => {
            updatedListKey[persona.persona_id] = {
                provide: persona.properties.open ? "Open" : "Reserved",
                follow: persona.properties.Receptive ? "Receptive" : "Needs_Persuasion",
            };
        });

        setListKey(updatedListKey);
    }
    const handleDelete = async (data: any) => {
        let payload = {
            admin_id: AdminId,
            user_id: useremail,
        }
        const response = await sessionsDeletePersona(data, payload);
        if (response.flag) {
            setError({
                show: true,
                class: "show-error",
                message: response?.message,
            });
            fetchSession();
        } else {
            setError({
                show: true,
                class: "show-error",
                message: response?.response?.data?.message,
            });
        }
    };
    const handleActive = async (data: any) => {
        let payload = {
            admin_id: AdminId,
            user_id: useremail,
        }
        const response = await sessionsActivePersona(data, payload);
        if (response.flag) {
            setError({
                show: true,
                class: "show-error",
                message: response?.message,
            });
            fetchSession();
        } else {
            setError({
                show: true,
                class: "show-error",
                message: response?.response?.data?.message,
            });
        }
    };

    useEffect(() => {
        if (props.show) {
            fetchPersonas();
            fetchSession();
        }
    }, []);
    useEffect(() => {
        setTraitsDetails(traits[traits?.length - 1] || "");
    }, [traits]);

    useEffect(() => {
        if (props.show) {
            fetchPersonas();
        }
    }, [props.show]);

    useEffect(() => {
        if (login) {
            fetchSession();
            const idAdmin = localStorage.getItem("AdminId");
            setAdminId(idAdmin);
        }
    }, [login]);


    useEffect(() => {
        const timer = setTimeout(() => {
            setError({
                show: false,
                class: "",
                message: "",
            });
            setErrorAdmin(false);
        }, 3000);
        return () => {
            clearTimeout(timer);
        };
    }, [errorAdmin, error]);

    const fetchPersonas = async () => {
        let param = `?type=paid`;
        const response = await getPersonas(param);
        if (response?.flag) {
            setPersonaList(response?.result?.data);
        }
    };
    const fetchSession = async () => {
        const AdminID = localStorage.getItem("AdminId");
        const response = await sessionList(AdminID, useremail);
        if (response?.flag) {
            setSessionList(response?.result?.data);
        }
    };

    const handleLogin = async () => {
        let payload = {
            user_id: useremail,
            password: password,
        };
        const response = await adminVerify(payload);
        if (response.flag) {
            localStorage.setItem("AdminId", response?.result?.admin?._id)
            setLogin(true);
        } else {
            setError({
                show: true,
                class: "show-error",
                message: response?.response?.data?.message,
            });
        }
    };

    const handleDownload = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${envUrls?.apiUrl}/${downloadSession}?admin_id=${AdminId}&user_id=${useremail}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            let filename = "Sessions.xlsx";
            const contentDisposition = response.headers.get("content-disposition");

            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);
                if (match) {
                    filename = match[1].replace(/["']/g, "").trim();
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click(); // Trigger download
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // Clean up memory
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <>
            {error.show && (
                <CustomError
                    class={`mt-3 ${error?.class} right-side`}
                    message={error?.message}
                />
            )}
            <Modal
                className="admin-modal"
                size={login && "xl"}
                show={props.show}
                onHide={props.onClose}
                keyboard={false}
                backdrop={!login ? true : "static"}
                centered
            >
                {!login ? (
                    <>
                        <Modal.Header className="justify-content-center pt-lg-4 pt-2">
                            <Modal.Title>Admin Login</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="pb-lg-5 pb-2">
                            <section className="login-page p-0">
                                <Container className="">
                                    <Row className=" align-items-center justify-content-center">
                                        <Col xxl={11} lg={10} md={12} className="text-center">
                                            <Stack className="mt-3">
                                                <InputGroup className="mb-3">
                                                    <input
                                                        className="form-control"
                                                        autoComplete="new-password"
                                                        placeholder="Enter your email"
                                                        onChange={(e: any) => setEmail(e.target.value)}
                                                    />
                                                </InputGroup>
                                                <InputGroup className="mb-3">
                                                    <input
                                                        className="form-control"
                                                        autoComplete="new-password"
                                                        placeholder="Password"
                                                        type={showPassword !== true ? "password" : "text"}
                                                        onChange={(e: any) => setPassword(e.target.value)}
                                                        onKeyDown={(key: any) => {
                                                            if (key.key === "Enter") {
                                                                handleLogin();
                                                            }
                                                        }}
                                                    />
                                                    <Button
                                                        onClick={() =>
                                                            setShowPassword((prevState) => !prevState)
                                                        }
                                                        type="button"
                                                        variant="eye-icon"
                                                    >
                                                        {showPassword ? eyeOn() : eyeOff()}
                                                    </Button>

                                                </InputGroup>
                                                <div>
                                                    <Button
                                                        type="button"
                                                        variant="secondary"
                                                        className="w-100"
                                                        onClick={() => handleLogin()}
                                                    >
                                                        <div className="my-1 weight-bold">Submit</div>
                                                    </Button>
                                                </div>
                                            </Stack>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        </Modal.Body>
                    </>
                ) : (
                    <>
                        <Modal.Header className="justify-content-between row g-0 py-2 text-center px-lg-4 px-2 border-bottom">
                            <Modal.Title className="col-md col-12 text-md-start text-center">
                                {!sessionCreate?.table && (
                                    <Button
                                        onClick={() => {
                                            setCreateSession({
                                                table: true,
                                                form: false,
                                            });
                                            setSessionDetails({
                                                session_id: "",
                                                session_name: "",
                                                password: "",
                                                admin_id: "",
                                            });
                                            setTraits([]);
                                            setEditSession(false);
                                            setValidationErrors({
                                                session_id: '',
                                                session_name: '',
                                                password: '',
                                                traits: '',
                                            });
                                        }}
                                        className="back-btn me-2"
                                    >
                                        {backIcon()}
                                    </Button>
                                )}
                                <span className="d-inline-block">
                                    {sessionCreate?.table ? "Session Management" : editSession ? "Edit Session" : "Add Session"}
                                </span>
                            </Modal.Title>
                            <Col md="auto">
                                {sessionCreate?.table ? (
                                    <>

                                        <Button onClick={() => {
                                            setCreateSession({
                                                table: false,
                                                form: true,
                                            });
                                        }}
                                            size="sm">
                                            Add Session
                                        </Button>

                                        <Button
                                            variant="secondary"
                                            className="ms-1"
                                            onClick={() => {
                                                handleDownload();
                                            }}
                                            size="sm">
                                            Export Session List
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        {/* <Button onClick={() => {
                                            setCreateSession({
                                                table: true,
                                                form: false,
                                            });
                                        }}>
                                            View List
                                        </Button> */}
                                    </>
                                )}

                            </Col>
                        </Modal.Header>
                        <Modal.Body className="update-persona p-lg-4 p-3 border-bottom login-page">
                            {sessionCreate?.table && (
                                <div className="table-radius">
                                    <div className="table-responsive">
                                        <Table className="m-0" bordered>
                                            <thead>
                                                <tr>
                                                    <th>Session ID</th>
                                                    <th>Session Name</th>
                                                    <th>Password</th>
                                                    <th
                                                        style={{
                                                            minWidth: "150px"
                                                        }}
                                                    >Personas</th>
                                                    <th>Status</th>
                                                    <th
                                                        style={{
                                                            minWidth: "100px"
                                                        }}
                                                    >Actions</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {sessionsList?.map((item: any, index: any) =>
                                                    <tr key={index}>
                                                        <td>
                                                            {item?.session_id}
                                                        </td>
                                                        <td>
                                                            {item?.session_name}
                                                        </td>
                                                        <td>
                                                            {item?.password}
                                                        </td>
                                                        <td>

                                                            <div className="text-uppercase d-inline-block me-1">
                                                                {item?.personas?.map((persona: any) => persona?.name).join(", ")}
                                                            </div>

                                                        </td>
                                                        <td>{item?.open ? <>
                                                            <Button size="sm" variant="success" className="btn status-btn">Active</Button>
                                                        </> : <>
                                                            <Button size="sm" variant="danger" className="btn status-btn">Inactive</Button>
                                                        </>
                                                        }</td>
                                                        <td>
                                                            {item?.open && (
                                                                <>
                                                                    <OverlayTrigger
                                                                        key="top"
                                                                        placement="top"
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-top`}>
                                                                                Edit Session
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <Button size="sm" className="back-btn" variant="secondary" onClick={() => handleEdit(item)}>
                                                                            {editIcon()}
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                </>
                                                            )}
                                                            {item?.open ? (
                                                                <OverlayTrigger
                                                                    key="top"
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-top`}>
                                                                            Deactivate
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Button
                                                                        size="sm"
                                                                        className="ms-2 back-btn"
                                                                        variant="primary"
                                                                        onClick={() => {
                                                                            if (window.confirm("Are you sure you want to Inactive this Session?")) {
                                                                                handleDelete(item?._id);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {userIcon()}
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <OverlayTrigger
                                                                    key="top"
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-top`}>
                                                                            Activate
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Button size="sm" className="back-btn" variant="secondary"
                                                                        onClick={() => {
                                                                            handleActive(item?._id);
                                                                        }}
                                                                    >
                                                                        {activeIcon()}
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            )}


                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            )}
                            {sessionCreate?.form && (
                                <div className="session-form">
                                    <Row className="g-2 align-items-center">
                                        <Col md={3}>
                                            <label>Session ID</label>
                                        </Col>
                                        <Col md={9}>
                                            <InputGroup className="">
                                                <input
                                                    className="form-control"
                                                    placeholder="Session ID"
                                                    value={sessionDetails.session_id}
                                                    onChange={(e: any) => {
                                                        setSessionDetails((prev: any) => ({
                                                            ...prev,
                                                            session_id: e?.target.value
                                                        }));
                                                    }}
                                                />
                                            </InputGroup>
                                            {validationErrors.session_id.trim() && (
                                                <div className="error-message">{validationErrors.session_id}</div>
                                            )}
                                        </Col>
                                        <Col md={3}>
                                            <label>Session Name</label>
                                        </Col>
                                        <Col md={9}>
                                            <InputGroup className="">
                                                <input
                                                    className="form-control"
                                                    placeholder="Session Name"
                                                    value={sessionDetails.session_name}
                                                    onChange={(e: any) => {
                                                        setSessionDetails((prev: any) => ({
                                                            ...prev,
                                                            session_name: e?.target.value
                                                        }));
                                                    }}
                                                />
                                            </InputGroup>
                                            {validationErrors.session_name.trim() && (
                                                <div className="error-message">{validationErrors.session_name}</div>
                                            )}
                                        </Col>

                                        <Col md={3}>
                                            <label>Password</label>
                                        </Col>
                                        <Col md={9}>
                                            <InputGroup className="">
                                                <input
                                                    className="form-control"
                                                    placeholder="Password"
                                                    onChange={(e: any) => {
                                                        setSessionDetails((prev: any) => ({
                                                            ...prev,
                                                            password: e?.target.value
                                                        }));
                                                    }}
                                                />
                                            </InputGroup>
                                            {validationErrors.password.trim() && (
                                                <div className="error-message">{validationErrors.password}</div>
                                            )}
                                        </Col>
                                        <Col md={3}>
                                            <label>Choose Personas</label>
                                        </Col>
                                        <Col md={9}>
                                            <Select
                                                isMulti
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                value={personaList
                                                    .filter((item: any) => traits.includes(item._id))
                                                    .map((item: any) => ({
                                                        value: item._id,
                                                        label: <div className="select-insideImage"><Image src={item?.image_url} className="me-1" alt="" />  <span className="text-capitalize">{item?.name}</span></div>,
                                                    }))
                                                }
                                                onChange={(selectedOptions: any) => {
                                                    const selectedValues = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];
                                                    setTraits(selectedValues);
                                                }}
                                                options={[
                                                    ...(personaList).filter((filter: any) => filter?.avalability !== "comming_soon").map((item: any) => ({
                                                        value: item._id,
                                                        label: <div className="select-insideImage"><Image className="me-1" height={36} width={36} style={{ borderRadius: "8px", objectFit: "cover" }} src={item?.image_url} alt="" />  <span className="text-capitalize">{item?.name}</span></div>,
                                                    })),
                                                ]}
                                            />
                                            {validationErrors.traits.trim() && (
                                                <div className="error-message">{validationErrors.traits}</div>
                                            )}
                                        </Col>
                                        <Col xs={12}>
                                            <div className="border-bottom my-2"></div>
                                            {traits.length > 0 ? (
                                                <Row>
                                                    <Col md={3}>
                                                        {personaList?.map((item: any) => <>
                                                            <div className="mt-2 me-1 d-md-block d-inline-block">
                                                                {traits.includes(item?._id) && (
                                                                    <>
                                                                        <div className="persona-select mb-1">
                                                                            <input className="main-checkbox"
                                                                                onChange={() => setTraitsDetails(item?._id)}
                                                                                checked={traitsDetails === item?._id}
                                                                                type="radio"
                                                                                name={"PersonaList"}
                                                                                value={item?._id}
                                                                            />
                                                                            <div className="inner-select d-flex align-items-center">
                                                                                <Image src={item?.image_url} alt="" />
                                                                                <div className="ms-2">
                                                                                    <h5 className="text-white text-capitalize">{item?.name}</h5>
                                                                                </div>
                                                                            </div>
                                                                            {/* {traits(item?._id) && (
                                                                        checkIcon()
                                                                    )} */}
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </>)}
                                                    </Col>
                                                    <Col md={9}>
                                                        <Row className="">
                                                            {traits.length > 0 && personaList
                                                                ?.filter((i: any) => traitsDetails === i?._id)
                                                                .map((item: any) => (
                                                                    <Col xs={12} key={item?._id}>
                                                                        <div className="select-traits">
                                                                            <div className="d-block">
                                                                                <FormLabel>Information Sharing</FormLabel>
                                                                                <div key={`inline-radio`} className="d-block">
                                                                                    <Form.Check
                                                                                        label="Open"
                                                                                        name={`provide${item?._id}`}
                                                                                        type="radio"
                                                                                        value="Open"
                                                                                        id={`inline-radio-1${item?._id}`}
                                                                                        checked={listKey[item?._id]?.provide === "Open"}
                                                                                        onChange={(e: any) =>
                                                                                            setListKey((prevState) => ({
                                                                                                ...prevState,
                                                                                                [item?._id]: {
                                                                                                    ...prevState[item?._id],
                                                                                                    provide: e.target.value,
                                                                                                },
                                                                                            }))
                                                                                        }
                                                                                    />
                                                                                    <Form.Check
                                                                                        value="Reserved"
                                                                                        label="Reserved"
                                                                                        name={`provide${item?._id}`}
                                                                                        type="radio"
                                                                                        id={`inline-radio-2${item?._id}`}
                                                                                        checked={listKey[item?._id]?.provide === "Reserved"}
                                                                                        onChange={(e: any) =>
                                                                                            setListKey((prevState) => ({
                                                                                                ...prevState,
                                                                                                [item?._id]: {
                                                                                                    ...prevState[item?._id],
                                                                                                    provide: e.target.value,
                                                                                                },
                                                                                            }))
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="mt-2 d-block">
                                                                                <FormLabel>Response to Recommendations</FormLabel>
                                                                                <div key={`inline-radio`} className="d-block">
                                                                                    <Form.Check
                                                                                        label="Receptive"
                                                                                        name={`follow${item?._id}`}
                                                                                        type="radio"
                                                                                        value="Receptive"
                                                                                        id={`inline-radio-3${item?._id}`}
                                                                                        checked={listKey[item?._id]?.follow === "Receptive"}
                                                                                        onChange={(e: any) =>
                                                                                            setListKey((prevState) => ({
                                                                                                ...prevState,
                                                                                                [item?._id]: {
                                                                                                    ...prevState[item?._id],
                                                                                                    follow: e.target.value,
                                                                                                },
                                                                                            }))
                                                                                        }
                                                                                    />
                                                                                    <Form.Check
                                                                                        value="Needs_Persuasion"
                                                                                        label="Reluctant"
                                                                                        name={`follow${item?._id}`}
                                                                                        type="radio"
                                                                                        id={`inline-radio-4${item?._id}`}
                                                                                        checked={listKey[item?._id]?.follow === "Needs_Persuasion"}
                                                                                        onChange={(e: any) =>
                                                                                            setListKey((prevState) => ({
                                                                                                ...prevState,
                                                                                                [item?._id]: {
                                                                                                    ...prevState[item?._id],
                                                                                                    follow: e.target.value,
                                                                                                },
                                                                                            }))
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                ))}

                                                        </Row>
                                                    </Col>
                                                </Row>
                                            ) :
                                                <>
                                                    <p className="m-0 text-center">Select Personas from above Dropdown</p>
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer className="justify-content-end mb-0 g-1 text-center px-lg-4 px-2 py-lg-2 py-1">
                            <Col md="auto" xs="auto">
                                {!sessionCreate?.table ? (
                                    <Button variant="secondary" onClick={() => handleSubmit()}>
                                        {editSession ? "Update" : "Save"} Session
                                    </Button>
                                ) :
                                    <>
                                        <Button size="sm" variant="secondary"
                                            onClick={() => {
                                                setLogin(false)
                                                props.onClose()
                                                setEmail("");
                                                setPassword("");
                                            }}
                                        >
                                            Close
                                        </Button>
                                    </>
                                }
                            </Col>
                        </Modal.Footer>
                    </>
                )}
            </Modal >
        </>
    );
};
export default AdminModal;
